import useSWR, { SWRConfiguration } from "swr";
import config from "../config";
import { UserDataType } from "../types/auth.type";
import { get } from "@/backend";

export interface UseUserType {
  user: UserDataType;
  error?: any;
  mutate?: any;
  loading?: boolean;
}

const useUser = (
  payload?: { name?: string; haltRequest?: boolean },
  options?: SWRConfiguration,
): UseUserType => {
  const { data, error, mutate, isLoading } = useSWR(
    payload?.haltRequest
      ? null
      : payload?.name
        ? `${config.AUTH_API_URL}/users/${payload.name}`
        : `${config.AUTH_API_URL}/user/me`,
    payload?.haltRequest ? null : get,
    {
      ...options,
      onSuccess: (data: { data: any }) => {
        const _data = data?.data;
        _data.projects = _data?.projects?.length;
        _data.domains = _data?.domains?.length;
        _data.teams = _data?.teams?.length;
      },
    },
  );

  return {
    user: data?.data,
    loading: isLoading,
    error: error,
    mutate,
  };
};
export default useUser;
